import { useMemo, useRef } from "react";

import classNames from "classnames/bind";
import Button from "common/blocks/Button";
import RichText from "common/blocks/RichText";
import type { ResolvedFAQ, ResolvedQA } from "resolvers/data/faqResolver";
import type { ResolvedItem, ResolvedRichText } from "resolvers/data/richTextResolver";
import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";
import slugify from "slugify";

import Wrapper from "../common/Wrapper";
import styles from "./FinanceOptionsExplained.module.scss";

const cx = classNames.bind(styles);

type FinanceOptionsExplainedProps = ResolvedRichText & { params: { openByDefault: string } };

const FinanceOptionsExplained = ({ params, ...props }: FinanceOptionsExplainedProps) => {
    const customOnClick = useRef<{ [key: string]: Function }>({});

    const contents = useMemo(
        () =>
            (
                (props.resolvedItems || []).find(
                    ({ type }: ResolvedItem) => type === ContentTypeCodenames.FAQ
                ) as ResolvedFAQ
            )?.questions,
        [props.resolvedItems]
    );

    return (
        <Wrapper>
            {contents?.length && (
                <>
                    <span className={cx("heading")}>Contents:</span>
                    <ol className={cx("contents")}>
                        {contents.map((question, index) => (
                            <li
                                key={`${question.index || index}-${slugify(question.question, {
                                    lower: true,
                                })}`}
                            >
                                <Button
                                    theme="textLink"
                                    onClick={() => {
                                        customOnClick.current &&
                                            customOnClick.current?.[
                                                `${question.index || index}-${slugify(
                                                    question.question,
                                                    { lower: true }
                                                )}`
                                            ]?.();
                                    }}
                                    ariaLabel={question.question}
                                >
                                    {question.question}
                                </Button>
                            </li>
                        ))}
                    </ol>
                </>
            )}

            <RichText
                {...props}
                props={{
                    faq: {
                        clearBackground: true,
                        openByDefaultAnchor: params.openByDefault,
                        handleCustomOpen: customOnClick,
                    },
                }}
            />
        </Wrapper>
    );
};

export default FinanceOptionsExplained;
